import axios from 'axios';
import applyCaseMiddleware from 'axios-case-converter';

import { COOKEY_KEY } from 'constants/cookieConstants';
import createAccessToken from './user/createAccessToken';
import { getCookie, removeCookieToken, setCookieToken } from 'utils/cookieUtils';

const apiClient = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
});

apiClient.interceptors.request.use(async (config) => {
  if (!config.headers.Authorization) {
    const accessToken = getCookie(COOKEY_KEY.ACCESS_TOKEN);
    const refreshToken = getCookie(COOKEY_KEY.REFRESH_TOKEN);

    if (accessToken && refreshToken) {
      apiClient.defaults.headers.common.Authorization = `Bearer ${accessToken}`;
      config.headers.Authorization = `Bearer ${accessToken}`;
    } else {
      removeCookieToken();
      window.location.href = process.env.REACT_APP_WEB_URL as string;
    }
  }

  return config;
});

apiClient.interceptors.response.use(
  (response) => response,
  async (error) => {
    const {
      response: { status, data },
    } = error;

    if (data.error_code === 11008) {
      // 유저 정보가 없을 때
      removeCookieToken();
      window.location.href = process.env.REACT_APP_WEB_URL as string;
    }

    if (status === 401) {
      const accessToken = getCookie(COOKEY_KEY.ACCESS_TOKEN);
      const refreshToken = getCookie(COOKEY_KEY.REFRESH_TOKEN);

      try {
        if (!refreshToken || !accessToken) throw new Error();

        const res = await createAccessToken({ refreshToken });
        if (res.result) {
          setCookieToken({
            accessToken: res.accessToken,
            refreshToken: res.refreshToken,
          });
          apiClient.defaults.headers.common.Authorization = `Bearer ${res.accessToken}`;
        } else {
          throw new Error();
        }
      } catch {
        removeCookieToken();
        window.location.href = process.env.REACT_APP_WEB_URL as string;
      }
    }

    return Promise.reject(error);
  }
);

export default applyCaseMiddleware(apiClient);
